import { LegalPage } from "@/components/LegalPage";
import { CONTACT } from "@/data/content";

const P = ({ children }) => <p className="mb-3 last:mb-0">{children}</p>;

const SECTIONS = [
  {
    heading: "What Cookies Are",
    body: <P>Cookies are small text files placed on your device by a website. Local storage is a similar browser feature. They allow a site to remember settings and understand how it is used.</P>,
  },
  {
    heading: "Strictly Necessary",
    body: (
      <P>
        This website stores a single local-storage value (<code className="rounded bg-cream px-1.5 py-0.5 font-mono text-xs">mg-cookie-consent</code>) to remember the choice you make in the cookie notice. It contains no personal information and is required for the notice to work.
      </P>
    ),
  },
  {
    heading: "Analytics",
    body: (
      <P>
        This website uses PostHog, a privacy-conscious product analytics tool, to understand which pages are visited and how the site performs. The data is used in aggregate to improve the site; it is not used to identify you personally or to serve advertising. If you choose "Necessary Only" in the cookie notice, analytics capture is switched off for your browser.
      </P>
    ),
  },
  {
    heading: "Advertising and Tracking",
    body: <P>We do not use advertising cookies, remarketing pixels or cross-site tracking on this website.</P>,
  },
  {
    heading: "Third-Party Content",
    body: <P>The map in our footer is embedded from Google Maps. When it loads, Google may set its own cookies under its own privacy policy. No other third-party embeds are present.</P>,
  },
  {
    heading: "Managing Cookies",
    body: <P>You can clear or block cookies and local storage in your browser settings at any time. Clearing them will cause the cookie notice to appear again on your next visit.</P>,
  },
  {
    heading: "Contact",
    body: <P>Questions about this policy: {CONTACT.email} · {CONTACT.phone}.</P>,
  },
];

export default function CookiePolicy() {
  return (
    <LegalPage
      testId="cookie-page"
      overline="Legal — Cookie Policy"
      title="Cookie Policy"
      lede="Which cookies and similar technologies this website uses, why, and how to control them."
      seoDescription="Cookie Policy for the My Geeks LLC website: strictly necessary storage, optional analytics, third-party embeds and how to manage your choices."
      sections={SECTIONS}
      updated="October 2, 2026"
    />
  );
}
